import { getServiceTypeOptions } from 'src/components/Cases/utils';

export const getCaseTypeType = (values) => values?.case_type?.type || values?.case_type;

export const getSelectedNetwork = (user, selectedNetworkId) => (
  user?.networks?.find((network) => network.id === selectedNetworkId)
);

export const hasProgramServiceTypes = (programsServiceTypes, programId) => (
  Boolean(programId) &&
  Object.prototype.hasOwnProperty.call(programsServiceTypes || {}, programId)
);

export const isServiceTypesReady = ({
  defaultProgramSelected,
  selectedNetwork,
  programsServiceTypes,
  programId,
}) => {
  const hasNetworkServiceTypes = Array.isArray(selectedNetwork?.service_types);
  const hasProgramServiceTypesValue = hasProgramServiceTypes(programsServiceTypes, programId);
  return defaultProgramSelected ? hasNetworkServiceTypes : hasProgramServiceTypesValue;
};

export const shouldDisableServiceTypes = ({
  values,
  caseTypeType,
  serviceTypesReady,
}) => (
  !values?.program ||
  (caseTypeType !== 'org_case' && !values?.network) ||
  !serviceTypesReady
);

export const resolveServiceTypeOptions = ({
  values,
  serviceTypesReady,
  defaultProgramSelected,
  user,
  programsServiceTypes,
}) => (
  values?.program && serviceTypesReady ? (
    getServiceTypeOptions({
      defaultProgramSelected,
      fields: values,
      user,
      programsServiceTypes,
    }) || []
  ) : []
);

export const resolveServiceTypeError = (meta = {}) => {
  const error = meta.error || meta.submitError;
  const showError = meta.touched || meta.submitError;
  return {
    error: showError ? error : undefined,
    invalid: showError && !!error,
    touched: showError,
  };
};
